export default "__VITE_ASSET__55ef5e35__"